import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import * as React from "react";
import { appIcons, appLogo } from "../../assets";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useNotifications from "../../hooks/useNotifications";
import { t } from "i18next";
import LanguageMenu from "../languageMenu";

const drawerWidth = 240;
const navItems = ["Home", "About", "Contact"];

function DashboardHeader(props) {
  const {
    notificationsLoading,
    allNotifications,
    fetchAllNotifications,
    markUserNotificationRead,
  } = useNotifications();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  React.useEffect(() => {
    if (window?.location.pathname === "/dashboard") {
      fetchAllNotifications();
    }
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        EaziDay
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    props.window !== undefined ? () => props.window().document.body : undefined;

  let filterArrr = allNotifications?.filter(
    (itemmmm) => !itemmmm.userStatus.isRead
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          backgroundColor: "text.white",
          boxShadow: " 0px -6.46px 14.53px 0px #00000021",
          // top: "40px",
          //   borderBottom: "1px solid #cdcdcd",
        }}
      >
        <Toolbar>
          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton> */}
          <Box sx={{ flexGrow: 1 }}>
            <Box width={130} mt={0.4}>
              <img
                src={appLogo.serviceProviderLogo}
                width={"100%"}
                height={"100%"}
                onClick={() => navigate("/")}
                style={{
                  cursor: "pointer",
                }}
              />
            </Box>
            <Typography
              sx={{ fontSize: "12px", color: "#7922d8", fontStyle: "italic" }}
            >
              {t("redefiningConvenienceAndEfficiency")}{" "}
            </Typography>
          </Box>
          <LanguageMenu />
          {window.location.pathname !== "/dashboard/notification" && (
            <Stack>
              <IconButton
                sx={{ position: "relative" }}
                onClick={() => {
                  markUserNotificationRead();
                  navigate("/dashboard/notification");
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    background: "#7922d8",
                    top: 0,
                    right: 0,
                    height: "20px",
                    width: "20px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography sx={{ color: "#ffff", fontSize: "12px" }}>
                    {filterArrr.length}
                  </Typography>
                </Box>
                <img
                  src={appIcons.purpleNotificationIcon}
                  alt="notification-icon"
                  style={{
                    width: 30,
                  }}
                />
              </IconButton>
            </Stack>
          )}
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box
        component="main"
        sx={{
          px: { xs: 1, sm: 3 },
          py: { xs: 8, sm: 8 },
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
          flexGrow: 1,
          overflow: "auto",
        }}
      >
        <Toolbar />
        {props.children}
      </Box>
    </Box>
  );
}

export default DashboardHeader;
